const CallToAction = () => (
  <section className="bg-gradient-to-r from-indigo-600 to-emerald-500 text-white py-16 text-center">
    <h2
      className="text-3xl md:text-4xl font-bold mb-6"
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="200"
    >Looking for a trusted real estate partner?</h2>
    <button
      className="px-8 py-3 bg-white text-indigo-700 font-semibold rounded-full hover:bg-gray-100 transition"

      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="400"

    >
      Join 121 Property Today
    </button>
  </section>
);

export default CallToAction;
